import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Depenses from "@/pages/Depenses";
import Fournisseurs from "@/pages/Fournisseurs";
import FournisseurDetail from "@/pages/FournisseurDetail";
import FacturesFournisseurs from "@/pages/FacturesFournisseurs";
import Caisse from "@/pages/Caisse";
import Banque from "@/pages/Banque";
import Rapports from "@/pages/Rapports";
import Parametres from "@/pages/Parametres";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import FacturesClients from "@/pages/FacturesClients";
import Achats from "@/pages/Achats";
import Stock from "@/pages/Stock";
import Livraisons from "@/pages/Livraisons";
import Inventaires from "@/pages/Inventaires";
import Production from "@/pages/Production";
import Recettes from "@/pages/Recettes";
import EtatStock from "@/pages/EtatStock";
import Immobilisations from "@/pages/Immobilisations";
import { StatistiquesPage, Etat104Page, ImpotsPage } from "@/pages/VentesEtats";
import EtablirG50 from "@/pages/EtablirG50";
import Cnas from "@/pages/Cnas";
import G50Etablis from "@/pages/G50Etablis";
import Employes from "@/pages/Employes";
import EmployeDocuments from "@/pages/EmployeDocuments";
import EmployeConges from "@/pages/EmployeConges";
import Douane from "@/pages/Douane";

const SANTE = ["convention_sante", "analyse"];
import Assistant from "@/pages/Assistant";
import Audit from "@/pages/Audit";
import ComingSoon from "@/pages/ComingSoon";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/depenses" element={<Depenses />} />
              <Route path="/factures-fournisseurs" element={<FacturesFournisseurs />} />
              <Route path="/fournisseurs" element={<Fournisseurs />} />
              <Route path="/etat-stock" element={<EtatStock />} />
              <Route path="/immobilisations" element={<Immobilisations />} />
              <Route path="/statistiques" element={<StatistiquesPage />} />
              <Route path="/etat-104" element={<Etat104Page />} />
              <Route path="/impots" element={<ImpotsPage />} />
              <Route path="/etablir-g50" element={<EtablirG50 />} />
              <Route path="/cnas" element={<Cnas />} />
              <Route path="/g50-etablis" element={<G50Etablis />} />
              <Route path="/employes" element={<Employes />} />
              <Route path="/employes/contrats" element={<EmployeDocuments key="c" types={["contrat"]} title="Contrats de travail" subtitle="Contrats signés de chaque employé (PDF ou photo)" />} />
              <Route path="/employes/sante" element={<EmployeDocuments key="s" types={SANTE} title="Convention santé et analyses" subtitle="Conventions médicales et analyses — alerte 30 jours avant expiration" />} />
              <Route path="/employes/paie" element={<EmployeDocuments key="p" types={["fiche_paie"]} title="Fiches de paie" subtitle="Bulletins de paie mensuels par employé" />} />
              <Route path="/employes/conges" element={<EmployeConges />} />
              <Route path="/douane/d10" element={<Douane key="d10" kind="d10" title="D10 et reçus" subtitle="Déclarations en douane et quittances — la TVA payée est déduite automatiquement dans le G50" />} />
              <Route path="/douane/transitaire" element={<Douane key="tr" kind="transitaire" title="Factures transitaire" subtitle="Frais de transit liés aux importations — TVA reprise dans le G50" />} />
              <Route path="/douane/frais" element={<Douane key="fr" kind="frais" title="Frais d'importation" subtitle="Fret, assurance, port, magasinage, transport, banque… — rattachés à leur D10, TVA reprise dans le G50" />} />
              <Route path="/fournisseurs/:id" element={<FournisseurDetail />} />
              <Route path="/caisse" element={<Caisse />} />
              <Route path="/banque" element={<Banque />} />
              <Route path="/rapports" element={<Rapports />} />
              <Route path="/parametres" element={<Parametres />} />
              <Route path="/achats" element={<Achats />} />
              <Route path="/ventes" element={<FacturesClients />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:id" element={<ClientDetail />} />
              <Route path="/stock" element={<Stock />} />
              <Route path="/livraisons" element={<Livraisons />} />
              <Route path="/inventaires" element={<Inventaires />} />
              <Route path="/production" element={<Production />} />
              <Route path="/recettes" element={<Recettes />} />
              <Route path="/assistant" element={<Assistant />} />
              <Route path="/audit" element={<Audit />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
